import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import LocalDate from '../LocalDate'
import LocalTime from '../LocalTime'
import ShowLocalNumber from '../ShowLocalNumber'
import MovimentoEntrUsc from './MovimentoEntrUsc'
import ModalConfirm from '../ModalConfirm'
import { Popup, Button, Dropdown } from 'semantic-ui-react'

class MovimentiTableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.onClickPreview = this.onClickPreview.bind(this);
        this.onDropdownChange = this.onDropdownChange.bind(this);
        this.onClickAssignDocument = this.onClickAssignDocument.bind(this);

        this.state = {
            options: [
                { key: 'download', icon: 'download', text: 'Scarica Documento', value: 'download' },
                { divider: true },
                { key: 'delete', icon: 'delete', text: 'Cancella Documento', value: 'delete' },
            ]
        };
    }

    onDropdownChange(val, movimento) {
        let value = val;

        console.log("Dropdown change:", value);
        console.log("Dropdown change:", movimento);

        // value: download|delete
        this.props.onDocumentAction(value, movimento);
    }

    onClickPreview(movimento) {
        this.props.onDocumentAction("preview", movimento);
    }

    onClickAssignDocument(movimento) {
        console.log("onClickAssignDocument:", movimento);
        this.props.onDocumentAction("assign", movimento);
    }

    render() {
        let m = this.props.movimento

        let btnDocumento = null;
        if (m.nomeDocumento && m.nomeDocumento !== ""){
            if(this.props.readOnly == false){
                btnDocumento = (
                    <Button.Group color='teal'>
                        <Button onClick={()=>this.onClickPreview(m)}>Visualizza</Button>
                        <Dropdown className='button icon' text=' ' button floating={true}>
                            <Dropdown.Menu>
                                <Dropdown.Header content='Altre opzioni:' />
                                <Dropdown.Item
                                    key={1}
                                    text="Scarica Documento"
                                    icon="download"
                                    onClick={()=> this.onDropdownChange("download",m)}
                                />
                                <Dropdown.Divider key={2}/>
                                <ModalConfirm
                                    msg={"Stai per cancellare il Documento associato al movimento selezionato con ID: " + m.idMovimento}
                                    onClickOk={()=> this.onDropdownChange("delete",m)}
                                >
                                    <Dropdown.Item
                                        key={3}
                                        text="Elimina Documento"
                                        icon="delete"
                                    />
                                </ModalConfirm>
    
                            </Dropdown.Menu>
                        </Dropdown>
                    </Button.Group>
                );                    
            }
            else{
                btnDocumento = (
                    <Button.Group color='teal'>
                        <Button onClick={()=>this.onClickPreview(m)}>Visualizza</Button>
                        <Dropdown className='button icon' text=' ' button floating={true}>
                            <Dropdown.Menu>
                                <Dropdown.Header content='Altre opzioni:' />
                                <Dropdown.Item
                                    key={1}
                                    text="Scarica Documento"
                                    icon="download"
                                    onClick={()=> this.onDropdownChange("download",m)}
                                />    
                            </Dropdown.Menu>
                        </Dropdown>
                    </Button.Group>
                );
    
            }
        }
        else{
            if(this.props.readOnly == false){
                btnDocumento = (
                    <a className="ui blue icon button"
                    title="Assegna un documento scannerizzato"
                    onClick={(ev) => (this.onClickAssignDocument(m))}>
                        <i className="file alternate outline icon"></i> Assegna</a>
                );
            }
            else{
                btnDocumento = "Non presente";
            }
        }
        let riservatoIcon = null;
        if (m.riservato){
            riservatoIcon = (<i className="lock icon"/>);
        }
        let btnModifica = null;
        let btnDelete = null;
        if(this.props.readOnly == false){
            btnModifica =(
                    <Link  className="ui blue icon button" to={`/app/movimenti/edit/${m.idMovimento}`}>
                        <i
                            className="edit icon"

                        ></i>
                    </Link>
            );
            btnDelete =(
                <ModalConfirm
                    msg={"Stai per cancellare il movimento: " + m.idMovimento}
                    onClickOk={(ev) => (this.props.onDeleteItem(ev, m))}
                >
                    <a className="ui red icon button"><i className="trash icon"/></a>
                </ModalConfirm>        
            );
        }

        return (
            <tr>
                <td className="collapsing center aligned">
                    {riservatoIcon}{m.idMovimento}
                </td>
                <td className="collapsing center aligned">
                    <MovimentoEntrUsc tipo={m.entrUsc}/>
                </td>
                <td className="collapsing">
                    <Popup
                        trigger={<i className="user icon pointer"/>}
                        on="click"
                        position="right center"
                        hideOnScroll
                        flowing
                    >
                        <Popup.Content>
                            <p>Creato il {m.creatoIl ?  <b><LocalDate data={m.creatoIl } /> <LocalTime data={m.creatoIl } /></b> : <b>?</b>} da <b>{m.creatoDa ? m.creatoDa.username : '?'}</b></p>
                            <p>Modificato il {m.modificatoIl ?  <b><LocalDate data={m.modificatoIl } /> <LocalTime data={m.modificatoIl } /></b> : <b>?</b>} da <b>{m.modificatoDa ? m.modificatoDa.username : '?'}</b></p>
                        </Popup.Content>
                    </Popup>
                    <LocalDate data={m.data} />
                </td>
                <td className="collapsing center aligned">{m.annoComp}</td>
                <td className="collapsing center aligned">{m.prevDef}</td>
                <td className="sorted descending"><Link to={`/app/movimenti/view/${m.idMovimento}`}>{m.idPdc.nomeCompleto}</Link></td>
                <td className="">
                    <Link to={`/app/movimenti/view/${m.idMovimento}`}>
                        {m.idCommessa ? m.idCommessa.nomeCompleto : ''}
                    </Link>
                </td>
                <td className=""><Link to={`/app/movimenti/view/${m.idMovimento}`}>{m.soggetto}</Link></td>
                <td className=""><Link to={`/app/movimenti/view/${m.idMovimento}`}>{m.estrConto}</Link></td>
                <td className=""><Link to={`/app/movimenti/view/${m.idMovimento}`}>{m.causale}</Link></td>
                <td className="collapsing"><Link to={`/app/movimenti/view/${m.idMovimento}`}>{m.forma}</Link></td>
                <td className="collapsing right aligned"><ShowLocalNumber value={m.corrispettivo}/></td>
                <td className="collapsing right aligned"><ShowLocalNumber value={m.pagamento}/></td>
                <td className="collapsing no-print center aligned">
                    {btnDocumento}
                </td>
                <td className="collapsing no-print">

                    {btnModifica}
                    {btnDelete}
                </td>
            </tr>)
    }
}

export default MovimentiTableRow;




/** WEBPACK FOOTER **
 ** ./src/components/movimenti/MovimentiTableRow.js
 **/